import { useLenis } from "lenis/react";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "../Reveal";

export default function FinalCTA() {
  const lenis = useLenis();
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) (lenis ? lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView({ behavior: "smooth" }));
  };
  const btn = "pp-btn group rounded-full border-2 border-white px-7 py-4 text-white transition-colors hover:bg-white hover:text-pp-red";
  return (
    <section data-testid="final-cta" className="relative overflow-hidden bg-pp-red py-28 md:py-40">
      <div className="noise absolute inset-0 opacity-100" />
      <div className="relative z-10 mx-auto max-w-[1500px] px-5 text-center md:px-10">
        <FadeUp>
          <h2 className="mx-auto max-w-4xl font-display text-5xl font-black leading-[0.92] tracking-tight text-white md:text-7xl lg:text-8xl">
            YOUR MEMORIES<br />ARE WORTH FRAMING.
          </h2>
          <p className="mx-auto mt-8 max-w-xl text-lg text-white/85">
            Print them. Frame them. Gift them. Keep them forever.
          </p>
          <div className="mt-12 flex flex-wrap justify-center gap-4">
            <button onClick={() => go("frames")} data-testid="finalcta-frames" className={btn}>
              Explore Frames <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </button>
            <button onClick={() => go("gifts")} data-testid="finalcta-gifts" className={btn}>
              Explore Photo Gifts <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </button>
            <button onClick={() => go("locations")} data-testid="finalcta-store" className={btn}>
              Visit Our Store <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
